import { isEqual } from 'lodash';

export const fetchingCEPFailed = (state) => (
  {
    ...state,
    isFetchingCep: false,
    cepNotFound: true
  }
);

export const fetchingCEPSuccess = (state) => (
  {
    ...state,
    isFetchingCep: false,
    cepNotFound: false
  }
);

export const fetchingCEPRequest = (state) => (
  {
    ...state,
    isFetchingCep: true,
    cepNotFound: undefined
  }
);

export const onRegisterDirtyField = (state, { form, fieldPath }) => {
  let formPathArray = [];

  if (state.dirtyForms[form] !== undefined && Array.isArray(state.dirtyForms[form])) {
    const paths = state.dirtyForms[form].filter(path => !isEqual(path, fieldPath));
    formPathArray = paths;
  }

  return {
    ...state,
    dirtyForms: {
      ...state.dirtyForms,
      [form]: [...formPathArray, fieldPath]
    }
  };
};
